import CheckboxCard from './CheckboxCard';

export default CheckboxCard;
